import React from 'react';
import { Link } from "react-router-dom";
import Spinner from '../others/Spinner';
import TablePagination from '../others/TablePagination';
import TableCountInfo from '../others/TableCountInfo';
import GroupSearch from './GroupSearch';
import config from '../../settings/config';
import Rest from '../../Server/Rest';
import _ from 'underscore';
import formatString from '../../utilities/format-string';
import GroupList from './GroupList';
import Parse from 'parse';

class GroupListCreditsIndividual extends GroupList {
    
    title = 'Créditos individuales';

    getResource = (index = 0, _where = {}) => {

        this.where = _where;

        this.setState(state => ({
            index: index
        }));
        
        this.handleSpinner();
        
        const newWhere = {
            ..._where,
            ...(_where.Grupo ? _where.Grupo.$select.query.where : {}),
            ...{
                grupo_reducido: true,
                Empleado: {
                    $exists: false
                }
            },
            ...Parse.User.current().toJSON().Sucursal ? {
                Sucursal: Parse.User.current().toJSON().Sucursal
            } : {},
            Solicitudes: {
                $inQuery: {
                    className: 'Solicitudes',
                    where: {
                        // prestamo_personalizado: true,
                        // prestamo_personalizado_interes: {
                        //     $exists: false
                        // },
                        prestamo_personalizado:{
                            $eq: true
                        },
                        prestamo_personalizado_interes: undefined,
                    }
                }
            }
        }
        delete newWhere.Grupo;
        

        const params = new URLSearchParams({
            include: 'Sucursal,Solicitudes,promotor,status',
            limit: this.limit,
            skip: parseInt(index),
            where: JSON.stringify(newWhere),
            count: 1,
            order: this.order,
            keys: 'nombre,id_busqueda,Sucursal.nombre,status,id_en_sucursal,Sucursal.sigla,Solicitudes.status,Solicitudes.ciclo,promotor,status',
        });

        let end_point = `${config.api_url}/classes/Grupos?${params.toString()}`;

        Rest.peticion(end_point, {
            method: 'GET',
        })
        .then(res => {
            return res.json();
        })
        .then(res => {
            return res;
        })
        .then(res => {
            console.log(res);
            if (res.code) {
                alert('Ha ocurrido un error inesperado. Intente más tarde.');
            } else {
                this.rows = res.count;
                this.setState({
                    collection: _.map(res.results, (item, index) => { item.index = index +1 + parseInt(this.state.index); return item; }),
                    total: res.count
                });
            }
        })
        .then(() => {
            this.handleSpinner();
        })
        .catch(error => {
            console.log('error --> ', error);
            this.handleSpinner();
            alert('Ha ocurrido un error inesperado. Intente más tarde.');
        });
    }

    setDate = (item) => {
        const d = formatString.setLegibleDate((item.fecha_registro && item.fecha_registro.iso)||item.createdAt);
        return  d;
    }

    setUrl = (item) => {
        return <Link to={`/creditos-individuales/${item.objectId}/datos-generales`} title="Ver" className="btn btn-link btn-lg">
            <i className="fas fa-chevron-right"></i>
        </Link>
    }

    setHead = <h3 className="text-uppercase text-pink pt-3 pb-3 d-flex">
        <i className="fas fa-user align-items-start mr-2">
            <small><small><i className="fas fa-dollar-sign"></i></small></small>
        </i>
        {this.title}

    </h3>

    render() {
        return(
            <>

                <Spinner loading={this.state.loading} />
                
                {this.setHead}

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col">
                                <GroupSearch handleFilter={this.handleFilter} />
                            </div>
                        </div>
                        <br />

                        <TableCountInfo total={this.state.total} />

                        <div className="table-responsive">    
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nombre</th>
                                    {/* <th scope="col">No. socios</th> */}
                                    <th scope="col">ID</th>
                                    <th scope="col">Sucursal</th>
                                    <th scope="col">Promotor</th>
                                    {/* <th scope="col">Ciclo actual</th> */}
                                    <th scope="col">
                                        Status
                                        <div className="dropdown float-right d-none">
                                            <div className="text-primary" type="button" id="dropdownOrderStatus" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-menu" aria-labelledby="dropdownOrderStatus">
                                                <h6 className="dropdown-header">Filtro por status</h6>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('')} value="">Status</button>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('activo')} value="activo">Activo</button>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('autorizacion')} value="autorizacion">Autorización</button>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('autorizado')} value="autorizado">Autorizado</button>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('baja')} value="baja">Baja</button>
                                                <button className="dropdown-item" type="button" onClick={() => this.setOrder('rechazado')} value="rechazado">Rechazado</button>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col">Fecha de registro</th>
                                    <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.collection.length ? this.state.collection.map((item, index) =>
                                            <tr key={index}>
                                                <td>{item.index}</td>
                                                <td className="td-responsive-text">
                                                    
                                                    {item.nombre}
                                                    
                                                </td>
                                                {/* <td>{item.Socios.length}</td> */}
                                                <td style={{whiteSpace: 'nowrap'}}>
                                                    <code className="text-body">{this.setID(item.id_en_sucursal, item.Sucursal)}</code>
                                                </td>
                                                <td>{this.setLugarRegistro(item.Sucursal)}</td>
                                                <td>{item.promotor.nombre} {item.promotor.apellido_paterno} {item.promotor.apellido_materno}</td>
                                                {/* <td>{this.setCycle(item.Solicitudes)}</td> */}
                                                <td className="text-uppercase">
                                                    {
                                                        // !(
                                                            // this.where.Grupo && this.where.Grupo.$select.query.where.status === 'fnc_cartera_vencida' ||
                                                            // this.where.Grupo && this.where.Grupo.$select.query.where.status === 'fnc_cartera_incobrable'
                                                        // ) && (
                                                            this.setStatus(item.status)
                                                        // ) || <button type="button" className="btn btn-warning">Cartera E.J.</button>
                                                    }
                                                </td>
                                                <td>{this.setDate(item)}</td>
                                                <td className="p-1 text-right">
                                                    {this.setUrl(item)}
                                                </td>
                                            </tr>
                                        ) : <tr>
                                            <td colSpan="8" className="text-center">
                                                <div className="alert alert-warning m-0" role="alert">
                                                     <i className="fas fa-filter"></i> Realice un filtro
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>    
                    
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <TableCountInfo total={this.state.total} />
                            </div>
                            <div className="col-md-6">
                                <TablePagination index={this.state.index} align="end" limit={this.limit} rows={this.rows} getData={this.getResource} where={this.where} />
                            </div>
                        </div>
                    
                    </div>
                </div>

                <div className="p-5"></div>
            </>
        )
    }

}

export default GroupListCreditsIndividual;